import * as Yup from "yup";
import { TFunction } from "i18next";

export const addAccessRightsFormValidationSchema = (t: TFunction) => {
    return Yup.object().shape({
        roleId: Yup.number().required(t("Fill this field")),
    });
};
